function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	document.addEventListener("usernavready", () => {
		const plus = document.querySelector("#_plus_info");
		if (plus?.dataset.enabled === "1" && plus?.dataset.payer === "0") {
			window.__tcfapi?.("addEventListener", 2, (tcData, success) => {
				if (
					!success ||
					(tcData.eventStatus !== "useractioncomplete" &&
						tcData.eventStatus !== "tcloaded")
				) {
					return;
				}
				const addiv = document.querySelector("#top_ads_container");
				if (addiv && addiv.offsetWidth === 0) {
					const btnAdBlockClose = document.querySelector(
						"#_adblock_popup_close",
					);
					const btnAdBlockTimer = document.querySelector(
						"#_adblock_popup_timer",
					);
					const popup_container = document.querySelector(
						"#adblock_popup_container",
					);
					import("basiclightbox").then((basicLightbox) => {
						const adblockLightbox = basicLightbox.create(popup_container, {
							closable: false,
						});
						let counterAdBlockClose = btnAdBlockTimer.dataset.counter;
						btnAdBlockTimer.innerHTML = counterAdBlockClose;
						adblockLightbox.show();

						const timer = setInterval(() => {
							btnAdBlockTimer.innerHTML = counterAdBlockClose;
							counterAdBlockClose--;
							if (counterAdBlockClose < 0) {
								btnAdBlockClose.classList.remove("d-none");
								btnAdBlockClose.classList.add("d-flex");
								clearInterval(timer);
							}
						}, 1200);

						document.body.style.overflow = "hidden";
						btnAdBlockClose.addEventListener("click", (event) => {
							event.preventDefault();
							adblockLightbox.close();
							document.body.style.overflow = "auto";
						});
					});
				}
			});
		}
	});
});
